/**
 * Creates a `StaticFilterValue`.
 *
 * @param config - The options with which to create a `StaticFilterValue`.
 * @returns A new `StaticFilterValue`.
 */
export function buildStaticFilterValue(config) {
    return {
        state: 'idle',
        ...config,
    };
}
